import React from "react";
import {
  Alert,
  Button,
  Col,
  Form,
  Icon,
  Input,
  Row,
  Select,
  TimePicker,
} from "antd";
import moment from "moment-timezone";
import {
  getApiTypeSchemaRequest,
  postApiTypeRequest,
  putApiTypeRequest,
  testApiTypeRequest,
  pullAllSubjectsRequest,
  pushAllSubjectsRequest, testMappingApiTypeRequest
} from "../../../api/requests";
import {
  getRunDFDiscoverApiConfigPermission,
  getRunRedcapApiConfigPermission
} from "../../../reducers/user/selectors";
import FormBuilderCustomView from "../../FormBuilder/FormBuilderCustomView";
import find from "lodash/find";
import get from "lodash/get";
import map from "lodash/map";
import {logout} from "../../../reducers/user/actions";
import {connect} from "react-redux";
import {withNamespaces} from "react-i18next";

const timezones = require("../../../utils/timezones.json");
const { Option } = Select;

class ApiConfigurationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      api_service_type: this.props.values.api_service_type || undefined,
      id: this.props.values.id || undefined,
      schema: null,
      loading: false,
      isTestLoading: false,
      testResponse: null,
    };
  }

  componentDidMount() {
    if (this.props.values.api_service_type) {
      this.getSchema();
    }
  }

  getSchema = async () => {
    try {
      const { data } = await getApiTypeSchemaRequest(
        this.state.api_service_type
      );
      this.setState({ schema: data });
    } catch (e) {
      console.log(e);
    }
  };

  testApiTypeRequest = async () => {
    this.setState({ isTestLoading: true, testResponse: null, });
    try {
      const { data } = await testApiTypeRequest(this.state.id);
      this.setState({ testResponse: { message: JSON.stringify(data), type: "success" } });
    } catch (e) {
      this.setState({
        testResponse: {
          message: get(e, "response.data.error"),
          type: "error",
        },
      });
    }

    this.setState({ isTestLoading: false });
  };

  testMappingApiTypeRequest = async () => {
    this.setState({ isTestLoading: true, testResponse: null, });
    try {
      const { data } = await testMappingApiTypeRequest(this.state.id);
      this.setState({ testResponse: { message: JSON.stringify(data), type: "success" } });
    } catch (e) {
      this.setState({
        testResponse: {
          message: get(e, "response.data.error"),
          type: "error",
        },
      });
    }

    this.setState({ isTestLoading: false });
  };

  getPreChildren = ({ getFieldDecorator }) => {
    return (
      <div>
        <Row style={{ width: "100%" }} gutter={12}>
          <Col md={12}>
            <Form.Item label={this.props.i18n.t("Name")}>
              {getFieldDecorator("name", {
                initialValue: this.props.values.name || undefined,
                rules: [
                  {
                    required: true,
                    message: this.props.i18n.t("Required"),
                  },
                ],
              })(<Input placeholder={this.props.i18n.t("Name")} />)}
            </Form.Item>
          </Col>
          <Col md={12}>
            <Form.Item label={this.props.i18n.t("URL")}>
              {getFieldDecorator("url", {
                initialValue: this.props.values.url || undefined,
                rules: [
                  {
                    required: true,
                    message: this.props.i18n.t("Required"),
                  },
                ],
              })(<Input placeholder={this.props.i18n.t("URL")} />)}
            </Form.Item>
          </Col>
          <Col md={24}>
            <Form.Item label={this.props.i18n.t("NamespaceApiConfiguration:Api action types")}>
              {getFieldDecorator("api_action_types", {
                initialValue: this.props.values.api_action_types || undefined,
                rules: [
                  {
                    required: true,
                    message: this.props.i18n.t("Required"),
                  },
                ],
              })(
                <Select
                  style={{ width: "100%" }}
                  placeholder={this.props.i18n.t("Select")}
                  mode="multiple"
                >
                  <Option value="create">{this.props.i18n.t("NamespaceApiConfiguration:CREATE")}</Option>
                  <Option value="pull">{this.props.i18n.t("NamespaceApiConfiguration:PULL")}</Option>
                  <Option value="push">{this.props.i18n.t("NamespaceApiConfiguration:PUSH")}</Option>
                  <Option value="push_after_randomization">{this.props.i18n.t("NamespaceApiConfiguration:PUSH AFTER RANDOMIZATION")}</Option>
                  <Option value="push_after_void">{this.props.i18n.t("NamespaceApiConfiguration:PUSH AFTER VOID")}</Option>
                  <Option value="push_after_consent">{this.props.i18n.t("NamespaceApiConfiguration:PUSH AFTER CONSENT")}</Option>
                  <Option value="info">{this.props.i18n.t("NamespaceApiConfiguration:INFO")}</Option>
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row style={{ width: "100%" }} gutter={12}>
          <Col md={8}>
            <Form.Item label={this.props.i18n.t("Scheduled time")}>
              {getFieldDecorator("scheduled_time", {
                initialValue: this.props.values.scheduled_time
                  ? moment(this.props.values.scheduled_time, "HH:mm:ss")
                  : undefined,
              })(
                <TimePicker
                  format="HH:mm:ss"
                  placeholder="HH:mm:ss"
                  showToday={false}
                />
              )}
            </Form.Item>
          </Col>
          <Col md={16}>
            <Form.Item label={this.props.i18n.t("Time zone")}>
              {getFieldDecorator("time_zone", {
                initialValue: this.props.values.time_zone || undefined,
              })(
                <Select showSearch placeholder={this.props.i18n.t("Select")}>
                  <Option value="">None</Option>
                  {timezones.map(({ utc }) =>
                    utc.map((tz, i) => (
                      <Option value={tz} key={i}>
                        {tz}
                      </Option>
                    ))
                  )}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
      </div>
    );
  };

  handleSubmit = async (values) => {
    const schema = get(this.state, "schema");
    const isUpload = Object.keys(schema).some((k) =>
      Object.keys(schema[k].fields).some(
        (o) => schema[k].fields[o].type === "InputUpload"
      )
    );

    let data = {};

    if (isUpload) {
      const formData = new FormData();

      Object.keys(values).forEach((key) => {
        if (values[key] && values[key].file) {
          formData.append(key, values[key].file);
        } else {
          formData.append(key, values[key]);
        }
      });

      data = formData;
    } else {
      data = { ...values };
    }
    data.scheduled_time = data.scheduled_time ? moment(data.scheduled_time).format("HH:mm:ss")  : null;
    data.api_connection_settings = {};

    Object.keys(schema).forEach((section) => {
      Object.keys(schema[section].fields).forEach((field) => {
        const fieldName = schema[section].fields[field].fieldName;
        data.api_connection_settings[fieldName] = values[fieldName];
        delete data[fieldName];
      });
    });

    if (this.state.id) {
      await putApiTypeRequest(data, this.state.id);
      this.props.onSubmit();
    } else {
      const result = await postApiTypeRequest(
        data,
        this.state.api_service_type
      );
      this.props.getApiConfiguration();
      this.setState({
        id: get(result, "data.id"),
      });
    }

    // try {
    //   console.log(data);
    //   // const { data: resultData } = await postCustomFormRandomization({
    //   //   ...data,
    //   // });
    //   //
    //   // this.setState({
    //   //   loading: true,
    //   // });
    //   //
    //   // this.setState({
    //   //   date: resultData.randomization_date,
    //   //   studyID: resultData.study_id,
    //   //   bottle_no: resultData.bottle_no,
    //   //   dose: resultData.dose,
    //   //   drug_dosage: resultData.drug_dosage,
    //   //   treatment_arm_name: resultData.treatment_arm_name,
    //   //   randomized: true,
    //   //   loading: false,
    //   // });
    // } catch (e) {
    //   if (get(e, "response.status") === 401) {
    //     this.props.logout();
    //   }
    //
    //   throw e;
    // }
  };

  pullAllSubjects = async () => {
    this.setState({ isPullAllSubjectsLoading: true });

    try {
      const { data } = await pullAllSubjectsRequest(this.state.id);
      this.setState({
        pullAllSubjectsResponse: get(data, 'message'),
      })
    } catch (e) {
      console.log(e);
    }

    this.setState({ isPullAllSubjectsLoading: false });
  };


  pushAllSubjects = async () => {
    this.setState({ isPushAllSubjectsLoading: true });

    try {
      const { data } = await pushAllSubjectsRequest(this.state.id);
      this.setState({
        pushAllSubjectsResponse: get(data, 'message'),
      })
    } catch (e) {
      console.log(e);
    }

    this.setState({ isPushAllSubjectsLoading: false });
  };

  render() {
    const { api_service_type, schema, isTestLoading, testResponse } = this.state;

    var canRunApiType = false;
    if (api_service_type == 'redcap' && this.props.getRunRedcapApiConfigPermission){
      canRunApiType = true
    }
    if (api_service_type == 'dfdiscover' && this.props.getRunDFDiscoverApiConfigPermission){
      canRunApiType = true
    }

    return (
      <div>
        <h4 className="headline-default">{this.props.i18n.t("NamespaceApiConfiguration:Api Configuration")}</h4>{" "}
        {api_service_type && (
          <div style={{ margin: "0 0 15px" }}>
            <b>{this.props.i18n.t("NamespaceApiConfiguration:Api service type")}:</b> {api_service_type}
          </div>
        )}
        {this.state.id && (
          <div
            style={{
              margin: "5px 0 20px",
              borderRadius: "3px",
              backgroundColor: "#f6f6f6",
              padding: "15px",
            }}
          >
            <Button
              type="primary"
              size="small"
              loading={isTestLoading}
              onClick={this.testApiTypeRequest}
              htmlType="button"
            >
              Test
            </Button>
            &nbsp;&nbsp;
            <Button
              type="default"
              size="small"
              loading={isTestLoading}
              onClick={this.testMappingApiTypeRequest}
              htmlType="button"
            >
              Test Mapping
            </Button>

            {testResponse && <Alert message={testResponse.message} type={testResponse.type} style={{ margin: '10px 0 0' }} />}
          </div>
        )}
        {this.state.id && this.props.getRunRedcapApiConfigPermission && (
          <div style={{ margin: '0 0 15px' }}>
            <Button
              type="primary"
              size="small"
              htmlType="button"
              loading={this.state.isPullAllSubjectsLoading}
              onClick={this.pullAllSubjects}
              disabled={this.state.pullAllSubjectsResponse}
            >
              {this.state.pullAllSubjectsResponse ? this.state.pullAllSubjectsResponse : this.props.i18n.t('NamespaceApiConfiguration:Pull all subjects')}
            </Button>
            &nbsp;&nbsp;
            <Button
              type="primary"
              size="small"
              htmlType="button"
              loading={this.state.isPushAllSubjectsLoading}
              onClick={this.pushAllSubjects}
              disabled={this.state.pushAllSubjectsResponse}
            >
              {this.state.pushAllSubjectsResponse ? this.state.pushAllSubjectsResponse : this.props.i18n.t('NamespaceApiConfiguration:Push all subjects')}
            </Button>
          </div>
        )}
        {!api_service_type && (
          <div>
            <Select
              showSearch
              value={api_service_type}
              placeholder={this.props.i18n.t("NamespaceApiConfiguration:Please select the API")}
              onChange={(val) => {
                this.setState({ api_service_type: val }, this.getSchema);
              }}
              style={{ width: "300px" }}
            >
              <Option value="redcap">{this.props.i18n.t("NamespaceApiConfiguration:RedCap")}</Option>
              <Option value="dfdiscover">{this.props.i18n.t("NamespaceApiConfiguration:DFDiscover")}</Option>
              <Option value="ibm" disabled>
                {this.props.i18n.t("NamespaceApiConfiguration:IBM")}
              </Option>
              <Option value="imednet" disabled>
                {this.props.i18n.t("NamespaceApiConfiguration:IMednet")}
              </Option>
            </Select>
          </div>
        )}
        {api_service_type && !schema && <Icon type="loading" />}
        {api_service_type && schema && (
          <FormBuilderCustomView
            isEditable
            schema={schema}
            initialValues={{
              ...this.props.values,
              ...this.props.values.api_connection_settings,
            }}
            preChildren={this.getPreChildren}
            onSubmit={this.handleSubmit}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  getRunRedcapApiConfigPermission: getRunRedcapApiConfigPermission(state),
  getRunDFDiscoverApiConfigPermission: getRunDFDiscoverApiConfigPermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "ApiConfigurationForm" })(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(ApiConfigurationForm))
);



// WEBPACK FOOTER //
// ./src/containers/ApiConfiguration/Form/ApiConfigurationForm.js